import { render, staticRenderFns } from "./PayrollReportGenerator.vue?vue&type=template&id=fc542a9e&"
import script from "./PayrollReportGenerator.vue?vue&type=script&lang=ts&"
export * from "./PayrollReportGenerator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports